import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import Shimmer from 'react-shimmer-effect';
import Carousel from '../../modules/Carousel';

class LatestNewsBlog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: [],
            captchaCode: null,
            LatestBlogs: [],
            fnameError: false,
            emailError: false,
            locationError: false,
            loadingMain: true,
            LanguageBasedLabel: [],
        };
    }

    componentDidMount() {
        const message = document.getElementById('langBasedMessage').getAttribute('value');
        const convertedMessage = JSON.parse(message);
        this.setState({ LanguageBasedLabel: convertedMessage });

        const app = document.getElementById('app');
        const { language } = app.dataset;

        const xhr = new XMLHttpRequest();
        xhr.open('GET', `/api/front/${language}/latestBlogs`);
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                const data = JSON.parse(xhr.response);
                this.setState({ LatestBlogs: data, loadingMain: false });

                const latestNews_carousel = Array.from(document.getElementsByClassName('latestNews_carousel'));
                latestNews_carousel.forEach((value) => {
                    const popularDestintaionCarouselElement = document.getElementById(value.id);
                    if (popularDestintaionCarouselElement !== null) {
                        const dealcarousel = new Carousel({
                            selector: popularDestintaionCarouselElement,
                            rotate: false,
                            loop: true,
                            perPage: {
                                0: 1,
                                768: 3,
                                992: 4,
                            },
                            prev: '#latestNews_carousel_prev',
                            next: '#latestNews_carousel_next',
                            nav: '#latestNews_carousel_nav',
                        });
                    }
                });
            } else {
                reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            }
        };
        xhr.onerror = () => {
            reject(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
        };
        xhr.send();
    }

    render() {
        const { errors, LatestBlogs } = this.state;
        console.log('this.state render', this.state);
        return (
            <div className="container mb-md-5">
                <h4 className="font-weight-bold text-black mb-3">{this.state.LanguageBasedLabel.Latest_News}</h4>

                <div className="row">
                    <div className="carousel-wrapper w-100">
                        <div className="controls d-none d-md-inline-block position-absolute" style={{ right: '20px', top: '-20px' }}>
                            <a href="#" id="latestNews_carousel_prev" className="prev carousel-square-btn off-set">
                                <div className="sr-only">{this.state.LanguageBasedLabel.Previous}</div>
                                <svg className="icon mr-md-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-triangle-left" />
                                </svg>
                            </a>
                            <a href="#" id="latestNews_carousel_next" className="next carousel-square-btn off-set">
                                <div className="sr-only">{this.state.LanguageBasedLabel.NEXT}</div>
                                <svg className="icon mr-md-2" aria-hidden="true">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-triangle-right" />
                                </svg>
                            </a>
                        </div>

                        <div id="" className="carousel-widget mt-2">
                            <div className="latest-offers-slider latestNews_carousel" id="latestNews_carousel">
                                {
                                    (LatestBlogs && LatestBlogs.length > 0 && LatestBlogs != '')
                                        ? LatestBlogs.map((value, index) => (
                                            <div className="d-flex pl-3 pr-3 mb-2 mb-md-0" key={`latestNews${index}`}>
                                                <div className="w-100 border rounded-sm deal-list-card">
                                                    <a id="latest-news-blogs" className="" href="/" data-latestnews-blogs={value.short_desc}>
                                                        <img
                                                            className="w-100 rounded-sm-top loaded"
                                                            data-src={value.img_url}
                                                            src={value.img_url}
                                                            data-was-processed="true"
                                                        />
                                                    </a>
                                                    <div className="p-3">
                                                        <div className="row gutter-10">
                                                            <div className="col-12">
                                                                <h6 className="font-weight-bold" target="" href="p">{value.short_desc}</h6>
                                                                <div className="text-muted mb-3 font-size-sm">{value.dateTime}</div>
                                                                <a id="latest-news-blogs" data-latestnews-blogs={value.short_desc} href="/" className="border-0 btn btn-warning text-dark font-size-sm font-weight-bold latest-news-blogs">{this.state.LanguageBasedLabel.Read_More}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        : null
                                }
                                {this.state.loadingMain
                                    ? (
                                        <>
                                            <div className="d-flex pl-3 pr-3 mb-2 mb-md-0">
                                                <div className="w-100 border rounded-sm deal-list-card">
                                                    <Shimmer>
                                                        <div className="w-100 rounded-sm-top loaded" style={{ height: 150 }} />
                                                    </Shimmer>
                                                    <div className="p-3">
                                                        <div className="row gutter-10">
                                                            <div className="col-12">
                                                                <Shimmer>
                                                                    <h6 className="w-100 font-weight-bold" style={{ height: 30 }}>&nbsp;</h6>
                                                                </Shimmer>
                                                                <Shimmer>
                                                                    <div className="w-100 text-muted mb-3 font-size-sm" style={{ height: 15 }}>&nbsp;</div>
                                                                </Shimmer>
                                                                <Shimmer>
                                                                    <div className="w-50 border-0 btn btn-warning   text-dark font-size-sm font-weight-bold" style={{ height: 15 }}>&nbsp;</div>
                                                                </Shimmer>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </>
                                    )
                                    : null}

                            </div>
                        </div>
                        <div id="latestNews_carousel_nav" className="mobile-btn-section text-center mb-2 d-md-none d-block" />
                        {/* <div id="" className="mobile-btn-section text-center mb-2 d-md-none">
                            <button className="carousel-square-btn active"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                            <button className="carousel-square-btn"></button>
                        </div> */}
                    </div>
                </div>

            </div>
        );
    }
}

export default LatestNewsBlog;
